import styled from "styled-components";

export const QuestionsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
